<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">QR kod weryfikacji KSeF</div>
            <div class="text-md text-secondary">Wyświetlaj QR kod z numerem KSeF na wydruku faktury</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <div class="flex items-center space-x-3">
            <mat-slide-toggle 
                color="primary"
                [checked]="showKsefQrCode"
                [disabled]="isProcessing"
                (change)="toggleShowKsefQrCode()">
            </mat-slide-toggle>
            <div class="text-sm text-gray-600 dark:text-gray-400">
                {{showKsefQrCode ? 'Włączone' : 'Wyłączone'}}
            </div>
        </div>
        
        <!-- Informacja o funkcji -->
        <div class="mt-4 text-xs text-gray-500 dark:text-gray-400">
            <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
            Po włączeniu, na wydruku faktury wysłanej do KSeF pojawi się QR kod umożliwiający weryfikację faktury w systemie KSeF.
        </div>
    </div>
</div>
